import Button from "@/components/Button/index";
import { ReactComponent as IconWarning } from "@/assets/svgs/icon-warning-circle.svg";
import { ReactComponent as IconClose } from "@/assets/svgs/icon-close.svg";
import CardConfigure from "@/componentsDS/Modal/CardConfigure";
import Modal from "@/componentsDS/Modal/Modal";
import ModalSelectedList from "@/components/ModalSelectedList/index";
import rem from '@/utils/rem';
import PropTypes from "prop-types";
import { feature } from "@/utils/feature-verifier";
import { featureConstant } from "@/constants/configuration/feature";
import { EnrolmentTypes } from "@/constants/use-case/enrolment";

const ModalContent = ({ selectedKey, selectedValue = false, removePrincipalType, principals, type, dataElementName, organisationName }) => {
	const isAgentPrincipalPhase2Enabled = feature(featureConstant.AGENT_PRINCIPAL_PHASE_2)

	const modalMessage = () => {
		switch(type?.toUpperCase()) {
			case EnrolmentTypes.provideOnBehalfOfPrincipal:
				return `Once removed, you will no longer be able to provide ${dataElementName} on behalf of these Principal(s).`
			case EnrolmentTypes.consumeOnBehalfOfPrincipal:
				return `Once removed, you will no longer be able to consume ${dataElementName} on behalf of these Principal(s).`
			case EnrolmentTypes.consumer:
				return `Once removed, ${organisationName} will no longer be able to provide ${dataElementName} on behalf of these Principal(s) to you.`
			case EnrolmentTypes.provider:
				return `Once removed, ${organisationName} will no longer be able to consume ${dataElementName} on behalf of these Principal(s) from you.`
			default:
				return `Once removed, you will no longer be able to provide or consume on behalf of these Principal(s).`
		}
	}

	return <>
		<div
			data-testid={"general-modal-content"}
			style={{ textAlign: "center" }}
		>
			{isAgentPrincipalPhase2Enabled ? (
					<p>Are you sure you want to remove the selected principal(s)?</p>
				) : (
					<p>Are you sure you want to remove the principal(s)?</p>
				)}
			<br />
			{!isAgentPrincipalPhase2Enabled && removePrincipalType === 'contributorView' ?
				<p>Once removed, you will lose the ability to contribute data to these principal(s).</p> :
				<p>{modalMessage()}</p>
			}
		</div >
		<br />
		<ModalSelectedList
			items={principals?.filter((p) => {
				return (
					p?.[selectedKey] && p.$selected === selectedValue
				);
			}).map(s => ({ ...s, uen: "UEN: " + s.uen }))}
			title="Selected Principal(s)"
			valueKey="name"
			subValueKey="uen"
		/>
		<div
			className="data-table__table__body"
			style={{ fontSize: rem(12) }}
		></div>
	</>
};

ModalContent.propTypes = {
	selectedKey: PropTypes.string.isRequired,
	removePrincipalType: PropTypes.string,
	principals: PropTypes.array,
	type: PropTypes.string,
	dataElementName: PropTypes.string,
	selectedValue: PropTypes.bool,
	organisationName: PropTypes.string,
};

const ConfirmRemovalOfPrincipalModal = ({ visible, hide, selectedKey, selectedValue = false, removePrincipalType, principals, submit, type, dataElementName, organisationName }) => {

	return (
		<Modal visible={visible} variant="medium" close={hide}>
			<CardConfigure addHeaderClass="principal-modal-header">
				<CardConfigure.Header>
					<CardConfigure.Header.Title>
					<div className="card-configure__header__left">
						<div className="card-configure__title">
							<div className="card-configure__title__left">
									<div className={'card-configure__rounded-square card-configure__icon--error'}>
										<IconWarning />
									</div>
							</div>
							<div className="card-configure__title__right">
								<div className="card-configure__title__right__top">
								Confirm Removal of Principal(s)
								</div>

							</div>
						</div>
					</div>
					</CardConfigure.Header.Title>
				</CardConfigure.Header>
				<CardConfigure.Body>
					<CardConfigure.Body.Col>
						{ModalContent({ selectedKey, principals, selectedValue, removePrincipalType, type, dataElementName, organisationName })}
					</CardConfigure.Body.Col>
				</CardConfigure.Body>
				<CardConfigure.Footer>
					<CardConfigure.Footer.Left>
						<Button
							data-testid="cancel-remove-persona-button"
							className="button--reset"
							ghost
							noborder
							round
							style={{ width: rem(80) }}
							submit={() => {
								hide();
							}}
							text={"Cancel"}
						></Button>
					</CardConfigure.Footer.Left>
					<CardConfigure.Footer.Right>
						<Button
							data-testid="confirm-remove-persona-button"
							className="button--reset"
							style={{ width: rem(80), marginLeft: rem(10) }}
							submit={() => {
								submit();
								hide();
							}}
							round
							text={"Confirm"}
						></Button>
					</CardConfigure.Footer.Right>
				</CardConfigure.Footer>
			</CardConfigure>
		</Modal>
	)
};

ConfirmRemovalOfPrincipalModal.propTypes = {
	visible: PropTypes.bool.isRequired,
	hide: PropTypes.bool.isRequired,
	selectedKey: PropTypes.string.isRequired,
	principals: PropTypes.array,
	type: PropTypes.string,
	dataElementName: PropTypes.string,
	removePrincipalType: PropTypes.string,
	selectedValue: PropTypes.bool,
	submit: PropTypes.func.isRequired,
	organisationName: PropTypes.string,
};

export default ConfirmRemovalOfPrincipalModal;
